var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hasPermission
    ? _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true },
            },
          ],
          class: `${_vm.buttonClass} inner-disabled`,
          attrs: {
            title: _vm.noPermissionMessage,
            variant: _vm.variant,
            size: _vm.size,
          },
        },
        [_vm._t("button-content")],
        2
      )
    : _vm.showTooltip
    ? _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true },
            },
          ],
          class: _vm.buttonClass,
          attrs: {
            title: _vm.title,
            variant: _vm.variant,
            size: _vm.size,
            disabled: _vm.disabled,
          },
          on: { click: _vm.clickButton },
        },
        [_vm._t("button-content")],
        2
      )
    : _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true },
            },
          ],
          class: _vm.buttonClass,
          attrs: {
            title: _vm.title,
            variant: _vm.variant,
            size: _vm.size,
            disabled: _vm.disabled,
          },
          on: { click: _vm.clickButton },
        },
        [_vm._t("button-content")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }